<div class="auth-layout-nav">
  <a
    class="inline-block no-underline outline-none"
    data-testid="logoBtn"
    [title]="'ABOUT_BLOCKS' | refData: ReferenceDataCatalogue.Accessibility"
    routerLink="/"
  >
    <aw-icon class="h-11 w-56" data-testid="logo" icon="blocks-dfsa_x2" />
  </a>
</div>

<div class="auth-form-wrapper flex w-full overflow-auto">
  <div class="relative flex h-full w-full flex-col md:w-auto">
    <div class="auth-form-container">
      <router-outlet class="hidden" />
    </div>
  </div>
</div>
